import styled from 'styled-components'

import { fontWeight, color, fontFamily } from '../../styles'

import { fontSize } from 'src/styles/fonts'

export const Wrap = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5.6rem;

  :disabled {
    background-color: rgba(87, 61, 57, 0.1);
  }

  svg {
    margin-right: 0.8rem;
  }

  p {
    font-size: ${fontSize.NORMAL};
    font-family: ${fontFamily.CATAMARAN};
    font-weight: ${fontWeight.SEMI};
    line-height: 1.5;
    text-align: center;
    color: ${color.WARM_GREY};
  }
`
